<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.join_delivery_details") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #ef3405">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <!-- البيانات الشخصية -->
        <div class="row mb-4">
          <div class="col-12 mb-3">
            <h5 class="section-title">{{ $t("PLACEHOLDERS.personal_data") }}</h5>
          </div>

          <!-- صورة شخصية -->
          <div class="col-12 mb-3" v-if="data.avatar">
            <div class="preview-container d-flex flex-column align-items-center gap-3">
              <p>{{ $t("PLACEHOLDERS.avatar") }}</p>
              <img
                :src="data.avatar"
                alt="Avatar"
                @click="openImagePreview(data.avatar)"
                style="cursor: pointer; width: 150px; height: 150px; border-radius: 50%; object-fit: cover;"
              />
            </div>
          </div>

          <!-- اسم المندوب -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.delivery_name')"
            v-model.trim="data.name"
            disabled
          />

          <!-- البريد الالكتروني -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.delivery_email')"
            v-model.trim="data.email"
            disabled
          />

          <!-- رقم الجوال -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.delivery_mobile')"
            v-model.trim="data.mobile"
            disabled
          />

          <!-- رقم الهوية -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.id_card_number')"
            v-model.trim="data.id_card_number"
            disabled
          />
        </div>

        <!-- بيانات السيارة -->
        <div class="row mb-4">
          <div class="col-12 mb-3">
            <h5 class="section-title">{{ $t("PLACEHOLDERS.vehicle_data") }}</h5>
          </div>

          <!-- رقم لوحة السيارة -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.vehicle_plate_number')"
            v-model.trim="data.vehicle_plate_number"
            disabled
          />

          <!-- صورة رخصة القيادة -->
          <div
            class="col-md-6 col-sm-6 col-12 preview-container d-flex flex-column align-items-center gap-3"
            v-if="data.driver_license"
          >
            <p>{{ $t("PLACEHOLDERS.driver_license") }}</p>
            <img
              :src="data.driver_license"
              alt="Driver License"
              @click="openImagePreview(data.driver_license)"
              style="cursor: pointer"
            />
          </div>
        </div>

        <!-- Action Buttons -->
        <!-- <div class="row" v-if="!data.is_approved_by_admin && data.is_approved_by_admin !== null">
          <div class="col-12 d-flex justify-content-center gap-3">
            <v-btn class="success_btn" @click="approveDelivery">
              <i class="fas fa-check"></i>
              {{ $t("BUTTONS.accept") }}
            </v-btn>
            <v-btn class="danger_btn" @click="dialogReject = true">
              <i class="fas fa-times"></i>
              {{ $t("BUTTONS.reject") }}
            </v-btn>
          </div>
        </div> -->
      </form>
    </div>
    <!-- END:: Single Step Form Content -->

    <!-- Image Preview Modal -->
    <v-dialog v-model="imagePreviewDialog" max-width="800">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span>{{ $t("PLACEHOLDERS.imagePreview") }}</span>
          <v-btn icon @click="imagePreviewDialog = false">
            <i class="fas fa-times"></i>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <img
            :src="previewImageUrl"
            alt="Preview"
            style="width: 100%; max-height: 70vh; object-fit: contain"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Reject Modal -->
    <v-dialog v-model="dialogReject" max-width="600">
      <v-card>
        <v-card-title class="text-h5 justify-center">
          {{ $t("TITLES.rejectConfirmingMessage", { name: data.name }) }}
        </v-card-title>

        <v-card-text>
          <form class="w-100">
            <base-input
              col="12"
              rows="3"
              type="textarea"
              :placeholder="$t('PLACEHOLDERS.reason_reject')"
              v-model.trim="rejectionReason"
              required
            />
          </form>
        </v-card-text>

        <v-card-actions>
          <v-btn
            class="modal_confirm_btn"
            @click="rejectDelivery"
            :disabled="!!!rejectionReason || rejectionReason?.length < 3"
          >
            {{ $t("BUTTONS.send") }}
          </v-btn>

          <v-btn class="modal_cancel_btn" @click="dialogReject = false">
            {{ $t("BUTTONS.cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ShowJoinDelivery",
  
  data() {
    return {
      // Start:: Data Collection
      data: {
        name: null,
        avatar: null,
        mobile: null,
        email: null,
        id_card_number: null,
        vehicle_plate_number: null,
        driver_license: null,
        is_approved_by_admin: null,
      },

      // Image Preview
      imagePreviewDialog: false,
      previewImageUrl: null,
      
      // Reject Dialog
      dialogReject: false,
      rejectionReason: null,
      // End:: Data Collection
    };
  },

  methods: {
    // Start:: Open Image Preview
    openImagePreview(imageUrl) {
      this.previewImageUrl = imageUrl;
      this.imagePreviewDialog = true;
    },
    // End:: Open Image Preview

    // Start:: Approve Delivery
    async approveDelivery() {
      try {
        const REQUEST_DATA = {
          is_approved_by_admin: true,
        };
        
        await this.$axios({
          method: "POST",
          url: `drivers/${this.$route.params.id}/toggle/approve`,
          data: REQUEST_DATA,
        });
        
        this.$message.success(this.$t("MESSAGES.deliveryApproved"));
        this.$router.push({ path: "/join_deliveries/all" });
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Approve Delivery

    // Start:: Reject Delivery
    async rejectDelivery() {
      try {
        const REQUEST_DATA = {
          is_approved_by_admin: false,
          rejection_reason: this.rejectionReason,
        };
        
        await this.$axios({
          method: "POST",
          url: `drivers/${this.$route.params.id}/toggle/approve`,
          data: REQUEST_DATA,
        });
        
        this.dialogReject = false;
        this.$message.success(this.$t("MESSAGES.deliveryRejected"));
        this.$router.push({ path: "/join_deliveries/all" });
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Reject Delivery

    // Start:: Get Data To Display
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `drivers/${this.$route.params.id}`,
        });
        
        const driver = res.data.data;
        
        // Set Driver Data
        this.data.name = driver.name;
        this.data.avatar = driver.avatar?.url || null;
        this.data.mobile = driver.phone_code + driver.mobile;
        this.data.email = driver.email;
        this.data.id_card_number = driver.id_card_number;
        this.data.vehicle_plate_number = driver.vehicle_plate_number;
        this.data.driver_license = driver.driver_license?.url || null;
        this.data.is_approved_by_admin = driver.is_approved_by_admin;
      } catch (error) {
        console.log(error.response.data.message);
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Get Data To Display
  },

  async created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
.preview-container img {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 15px;
}

.section-title {
  color: #ef3405;
  font-weight: bold;
  padding-bottom: 10px;
  border-bottom: 2px solid #ef3405;
  margin-bottom: 15px;
}

.success_btn {
  background-color: #28a745 !important;
  color: white !important;
}

.danger_btn {
  background-color: #dc3545 !important;
  color: white !important;
}
</style>
